import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab069f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "OrderFooter_MainArea"
}
const _hoisted_2 = { class: "OrderFooter_Select" }
const _hoisted_3 = { class: "OrderFooter_Count" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "数量一括設定", -1))
const _hoisted_5 = { class: "OrderFooter_Total" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OrderFooter_Total_Title" }, "合計点数", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OrderFooter_Total_Title" }, "合計数", -1))
const _hoisted_8 = { class: "OrderFooter_FlexWrap" }
const _hoisted_9 = {
  key: 1,
  class: "OrderFooter_MainArea"
}
const _hoisted_10 = {
  key: 0,
  class: "OrderFooter_Select"
}
const _hoisted_11 = { class: "OrderFooter_Count" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "一括注文", -1))
const _hoisted_13 = {
  key: 1,
  class: "OrderFooter_Select_SP"
}
const _hoisted_14 = { class: "OrderFooter_Count" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注文数量", -1))
const _hoisted_16 = {
  key: 2,
  class: "OrderFooter_CountCheck"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "OrderFooter_FlexWrap" }

import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import InputCheckBox from "../components/atoms/Input/InputCheckBox.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFooter',
  props: {
  isActive_SidebarFlg: { type: Boolean },
  fromOrderSearch: { type: Boolean },
  countSelectedSyosi: { type: String },
  // カート照会関連
  fromCartNormal: { type: Boolean },
  totalItem: { type: Number },
  totalNumber: { type: Number },
},
  emits: ["change", "updateNum", "addCart"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const $router = useRouter();

let selectFlg = ref(false);
let orderNum = ref(1);

const toggleSelectBox = (flg: boolean) => {
  //孫から受け取ったtrue/falseを親に送る
  selectFlg.value = flg;
  emit("change", selectFlg.value);
};
let incOrderNum = () => {
  if (orderNum.value < 50) {
    orderNum.value++;
    emitInputNum(Number(orderNum.value));
  }
};
let decOrderNum = () => {
  if (orderNum.value > 0) {
    orderNum.value--;
    emitInputNum(Number(orderNum.value));
  }
};
const validateQuantity = () => {
  if (String(orderNum.value) === "") {
    emitInputNum(0);
  }
  //符号無し整数を判定
  else if (!String(orderNum.value).match(/^[0-9]+$/)) {
    orderNum.value = 0;
  } else {
    emitInputNum(Number(orderNum.value));
  }
};
const emitInputNum = (quantity: number) => {
  emit("updateNum", quantity);
};
let addOrderToCart = () => {
  emit("addCart");
};
let toOrderSearch = () => {
  $router.push("/orderSearch");
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OrderFooter", {
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    (props.fromCartNormal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(InputCheckBox, {
              onChange: toggleSelectBox,
              class: "Move_With_Enter"
            }),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(decOrderNum) && _unref(decOrderNum)(...args))),
                class: "OrderFooter_Count_Decr Move_With_Enter"
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "minus" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "OrderFooter_Count_Num Move_With_Enter",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(orderNum) ? (orderNum).value = $event : orderNum = $event)),
                onInput: validateQuantity
              }, null, 544), [
                [_vModelText, _unref(orderNum)]
              ]),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(incOrderNum) && _unref(incOrderNum)(...args))),
                class: "OrderFooter_Count_Incr Move_With_Enter"
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "plus" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, [
              _hoisted_6,
              _createTextVNode("：" + _toDisplayString(props.totalItem) + "点 ", 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_7,
              _createTextVNode("：" + _toDisplayString(props.totalNumber) + "冊 ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(addOrderToCart) && _unref(addOrderToCart)(...args))),
              class: "OrderFooter_CartButton_Middle Move_With_Enter"
            }, " 登録 ")
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (props.fromOrderSearch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(InputCheckBox, { onChange: toggleSelectBox }),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(decOrderNum) && _unref(decOrderNum)(...args))),
                    class: "OrderFooter_Count_Decr"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "minus" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "OrderFooter_Count_Num",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(orderNum) ? (orderNum).value = $event : orderNum = $event)),
                    onInput: validateQuantity
                  }, null, 544), [
                    [_vModelText, _unref(orderNum)]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(incOrderNum) && _unref(incOrderNum)(...args))),
                    class: "OrderFooter_Count_Incr"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "plus" })
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(decOrderNum) && _unref(decOrderNum)(...args))),
                    class: "OrderFooter_Count_Decr"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "minus" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "OrderFooter_Count_Num",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(orderNum) ? (orderNum).value = $event : orderNum = $event)),
                    onInput: validateQuantity
                  }, null, 544), [
                    [_vModelText, _unref(orderNum)]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(incOrderNum) && _unref(incOrderNum)(...args))),
                    class: "OrderFooter_Count_Incr"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "plus" })
                  ])
                ])
              ])),
          (props.fromOrderSearch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createTextVNode(" 選択中の書誌"),
                _hoisted_17,
                _createTextVNode(_toDisplayString(__props.countSelectedSyosi) + "点 ", 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(addOrderToCart) && _unref(addOrderToCart)(...args))),
              class: "OrderFooter_CartButton"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "cart-shopping",
                class: "OrderFooter_CartButton_Icon"
              }),
              _createTextVNode("カートに追加 ")
            ]),
            _withDirectives(_createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(toOrderSearch) && _unref(toOrderSearch)(...args))),
              class: "OrderFooter_DownloadButton"
            }, " 検索一覧にもどる ", 512), [
              [_vShow, !props.fromOrderSearch]
            ])
          ])
        ]))
  ], 2))
}
}

})